export function assertNonNullable(value: unknown, variableName?: string): asserts value {
	if (value === undefined || value === null) {
		throw new Error(`RuntimeError: Assertion failed. Variable "${variableName}" should not be "${value}".`);
	}
}

export function assertTrue(expression: boolean, expressionText?: string, data?: unknown): asserts expression {
	if (!expression) {
		if (expressionText !== undefined && data !== undefined) {
			// eslint-disable-next-line no-console
			console.debug(`Expression "${expressionText}" is not true.`, data);
		}

		throw Error(
			expressionText
				? `RuntimeError: Assertion failed. Expression "${expressionText}" is not true.`
				: `RuntimeError: Assertion failed. Expression is not true.`
		);
	}
}
